import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ spacing, zIndex }) => ({
  container: ({ isMobile }: { isMobile: boolean }) => ({
    position: 'absolute',
    top: `calc(50% - ${isMobile ? 65 : 0}px)`,
    right: spacing(2),
    transform: 'translateY(-50%)',
    zIndex: zIndex.mobileStepper,
  }),
  checkBoxBase: ({ isMobile }: { isMobile: boolean }) => ({
    padding: spacing(isMobile ? 0.7 : 1),
  }),
  checkBoxLabel: {
    marginRight: 0,
  },
}));

export default useStyles;
